mutation UpdateCompanyPhoneVerificationSettingsForValuation(
  $input: UpdateCompanyPhoneVerificationSettingsForValuationInput!
) {
  updateCompanyPhoneVerificationSettingsForValuation(input: $input) {
    company {
      enabledPhoneVerification {
        VALUATION
      }
    }
  }
}
